export default __webpack_public_path__ + "3e2b8101112f208cbac274b32e7e8944.svg";